// extracted by mini-css-extract-plugin
export var gatsby_highlight = "code-module--gatsby_highlight--6cd88";